import { Map as MaplibreMap } from 'maplibre-gl';

export async function generateImages(map: MaplibreMap) {
    const canvas = new OffscreenCanvas(8, 8);
    const ctx = canvas.getContext('2d')!;

    // TCF fills
    // C3
    ctx.clearRect(0, 0, 8, 8);
    ctx.lineWidth = 1;
    ctx.strokeStyle = 'rgba(107,162,206,1)';
    ctx.lineCap = 'square';
    ctx.beginPath();
    ctx.moveTo(2, 6);
    ctx.lineTo(6, 2);
    ctx.stroke();
    map.addImage('tcf-c3-p1', canvas.transferToImageBitmap());

    ctx.clearRect(0, 0, 8, 8);
    ctx.lineWidth = 1;
    ctx.strokeStyle = 'rgba(128,128,128,1)';
    ctx.lineCap = 'square';
    ctx.beginPath();
    ctx.moveTo(2, 6);
    ctx.lineTo(6, 2);
    ctx.stroke();
    map.addImage('tcf-c3-p2', canvas.transferToImageBitmap());

    // C2
    ctx.clearRect(0, 0, 8, 8);
    ctx.lineWidth = 1;
    ctx.strokeStyle = 'rgba(107,162,206,1)';
    ctx.lineCap = 'square';
    ctx.beginPath();
    ctx.moveTo(0, 8);
    ctx.lineTo(8, 0);
    ctx.stroke();

    ctx.moveTo(4, 8);
    ctx.lineTo(8, 4);
    ctx.stroke();

    ctx.moveTo(0, 4);
    ctx.lineTo(4, 0);
    ctx.stroke();
    map.addImage('tcf-c2-p1', canvas.transferToImageBitmap());

    ctx.clearRect(0, 0, 8, 8);
    ctx.lineWidth = 1;
    ctx.strokeStyle = 'rgba(128,128,128,1)';
    ctx.lineCap = 'square';
    ctx.beginPath();
    ctx.moveTo(0, 8);
    ctx.lineTo(8, 0);
    ctx.stroke();

    ctx.moveTo(4, 8);
    ctx.lineTo(8, 4);
    ctx.stroke();

    ctx.moveTo(0, 4);
    ctx.lineTo(4, 0);
    ctx.stroke();
    map.addImage('tcf-c2-p2', canvas.transferToImageBitmap());

    // TFR
    ctx.clearRect(0, 0, 8, 8);
    ctx.lineWidth = 0.5;
    ctx.strokeStyle = 'rgb(255,0,0)';
    ctx.lineCap = 'square';
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(8, 8);
    ctx.stroke();

    ctx.moveTo(0, 8);
    ctx.lineTo(8, 0);
    ctx.stroke();
    map.addImage('tfr-pattern', canvas.transferToImageBitmap());

    // rect outline
    ctx.clearRect(0, 0, 8, 8);
    ctx.strokeStyle = 'black';
    ctx.lineWidth = 1;
    ctx.strokeRect(1, 1, 6, 6);
    map.addImage('rect-outline', canvas.transferToImageBitmap(), {
        content: [2, 2, 5, 5],
        stretchX: [[4, 5]],
        stretchY: [[4, 5]]
    });

    // rect outline
    ctx.clearRect(0, 0, 8, 8);
    ctx.strokeStyle = 'white';
    ctx.lineWidth = 1;
    ctx.strokeRect(1, 1, 6, 6);
    map.addImage('rect-outline-dark', canvas.transferToImageBitmap(), {
        content: [2, 2, 5, 5],
        stretchX: [[4, 5]],
        stretchY: [[4, 5]]
    });

    // rect outline-nat
    ctx.clearRect(0, 0, 8, 8);
    ctx.fillStyle = 'rgb(152, 179, 217)';
    ctx.roundRect(1, 1, 6, 6, 4);
    ctx.fill();
    map.addImage('rect-nat', canvas.transferToImageBitmap(), {
        content: [2, 2, 5, 5],
        stretchX: [[4, 5]],
        stretchY: [[4, 5]]
    });

    // rect outline-nat
    ctx.clearRect(0, 0, 8, 8);
    ctx.fillStyle = 'rgb(223, 183, 179)';
    ctx.roundRect(1, 1, 6, 6, 4);
    ctx.fill();
    map.addImage('rect-pat', canvas.transferToImageBitmap(), {
        content: [2, 2, 5, 5],
        stretchX: [[4, 5]],
        stretchY: [[4, 5]]
    });
    canvas.width = 32;
    canvas.height = 32;
    // tropo shield
    ctx.clearRect(0, 0, 32, 32);
    ctx.strokeStyle = 'black';
    ctx.lineWidth = 1;
    ctx.lineJoin = 'round';
    ctx.lineCap = 'round';
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(32, 0);
    ctx.lineTo(32, 16);
    ctx.lineTo(16, 32);
    ctx.lineTo(0, 16);
    ctx.closePath();
    ctx.stroke();
    map.addImage('tropo-shield', canvas.transferToImageBitmap(), {
        content: [2, 2, 30, 30],
        stretchX: [[2, 30]],
        stretchY: [[2, 30]]
    });

    canvas.width = 64;
    canvas.height = 64;
    ctx.clearRect(0, 0, 64, 64);
    ctx.strokeStyle = 'red';
    ctx.lineWidth = 1;
    ctx.lineJoin = 'round';
    ctx.lineCap = 'round';
    ctx.moveTo(0, 16);
    ctx.bezierCurveTo(32, 48, 32, 48, 64, 16);
    ctx.stroke();
    map.addImage('cloud-pattern', canvas.transferToImageBitmap());

    // ---
    canvas.width = 32;
    canvas.height = 32;
    ctx.strokeStyle = 'rgb(192,0,0)';
    ctx.fillStyle = 'rgb(192,0,0)';

    ctx.clearRect(0, 0, 32, 32);
    ctx.beginPath();
    ctx.moveTo(0, 16);
    ctx.lineTo(32, 16);
    ctx.lineWidth = 2;
    ctx.stroke();

    ctx.beginPath();
    ctx.arc(16, 16, 6, 0, -Math.PI);
    ctx.fill();

    //ctx.beginPath();
    //ctx.arc(22, 16, 5, 0, -Math.PI);
    //ctx.fill();
    map.addImage('front-warm', canvas.transferToImageBitmap());

    // ---
    ctx.strokeStyle = 'rgb(0,0,127)';
    ctx.fillStyle = 'rgb(0,0,127)';
    ctx.fill(new Path2D('M 16 8 l 6 0 l-6 11 l-6 -11z'));
    //ctx.fill(new Path2D('M 22 8 l 8 0 l-4 10z'));
    ctx.stroke(new Path2D('M 0 8 l32 0'));
    map.addImage('front-cold', canvas.transferToImageBitmap());

    // ---
    canvas.width = 64;
    canvas.height = 32;
    ctx.strokeStyle = 'rgb(127,0,127)';
    ctx.fillStyle = 'rgb(127,0,127)';

    ctx.clearRect(0, 0, 32, 32);
    ctx.beginPath();
    ctx.moveTo(0, 16);
    ctx.lineTo(64, 16);
    ctx.lineWidth = 3;
    ctx.stroke();

    ctx.moveTo(16, 16);
    ctx.arc(16, 16, 8, 0, -Math.PI);
    ctx.fill();

    ctx.beginPath();
    ctx.moveTo(32 + 8, 16);
    ctx.lineTo(32 + 24, 16);
    ctx.lineTo(32 + 16, 8);
    ctx.closePath();
    ctx.fill();
    map.addImage('front-occluded', canvas.transferToImageBitmap());

    //---
    canvas.width = 32;
    canvas.height = 32;
    ctx.lineWidth = 3;
    ctx.strokeStyle = 'rgb(127,64,0)';
    ctx.stroke(new Path2D('M0,16 l32,0'));
    map.addImage('front-tropical-wave', canvas.transferToImageBitmap());

    //---
    canvas.width = 32;
    canvas.height = 32;
    ctx.lineWidth = 2;
    ctx.setLineDash([10, 4]);
    ctx.strokeStyle = 'rgb(127,64,0)';
    ctx.stroke(new Path2D('M0,16 l32,0'));
    map.addImage('front-surface-through', canvas.transferToImageBitmap());

    // ---
    canvas.width = 32;
    canvas.height = 32;
    ctx.lineWidth = 2;
    ctx.setLineDash([8.5, 3, 3, 3, 3, 3, 8.5]);
    ctx.strokeStyle = 'rgb(192,0,0)';
    ctx.stroke(new Path2D('M0,16 l32,0'));
    map.addImage('front-squall', canvas.transferToImageBitmap());

    //---
    canvas.width = 32;
    canvas.height = 32;
    ctx.lineWidth = 2;
    ctx.strokeStyle = 'rgb(127,64,0)';
    ctx.fillStyle = 'rgb(127,64,0)';
    ctx.beginPath();
    ctx.arc(8, 16, 8, -Math.PI, 0);
    ctx.closePath();
    ctx.fill();

    ctx.beginPath();
    ctx.arc(24, 16, 8, -Math.PI, 0);
    ctx.closePath();
    ctx.fill();

    map.addImage('front-dry-line', canvas.transferToImageBitmap());

    // ---
    canvas.width = 64;
    canvas.height = 64;
    ctx.lineWidth = 2;
    ctx.strokeStyle = 'rgb(0,0,127)';
    ctx.fillStyle = 'rgb(0,0,127)';
    ctx.fill(new Path2D('M 16 32 l 6 0 l-6 11 l-6 -11z'));
    ctx.stroke(new Path2D('M 0 32 l32 0'));
    ctx.strokeStyle = 'rgb(192,0,0)';
    ctx.fillStyle = 'rgb(192,0,0)';
    ctx.stroke(new Path2D('M32,32 l32,0'));
    ctx.fill(new Path2D('M40,32 a6,6,0,0,1,16,0'));
    map.addImage('front-cold-warm', canvas.transferToImageBitmap());

    // ---
    canvas.width = 64;
    canvas.height = 64;
    ctx.lineWidth = 2;
    ctx.strokeStyle = 'rgb(192,0,0)';
    ctx.fillStyle = 'rgb(192,0,0)';
    ctx.stroke(new Path2D('M0,32 l32,0'));
    ctx.fill(new Path2D('M8,32 a6,6,0,0,1,16,0'));
    ctx.strokeStyle = 'rgb(0,0,127)';
    ctx.fillStyle = 'rgb(0,0,127)';
    ctx.fill(new Path2D('M48 32 l 6 0 l-6 11 l-6 -11z'));
    ctx.stroke(new Path2D('M32 32 l32 0'));
    map.addImage('front-stationary', canvas.transferToImageBitmap());

    // ---
    canvas.width = 64;
    canvas.height = 64;
    ctx.lineWidth = 2;
    ctx.strokeStyle = 'rgb(0,0,127)';
    ctx.fillStyle = 'rgb(0,0,127)';
    ctx.fill(new Path2D('M 16 32 l 6 0 l-6 11 l-6 -11z'));
    ctx.stroke(new Path2D('M 0 32 l32 0'));
    ctx.strokeStyle = 'rgb(192,0,0)';
    ctx.fillStyle = 'rgb(192,0,0)';
    ctx.stroke(new Path2D('M32,32 l32,0'));
    ctx.fill(new Path2D('M40,32 a6,6,0,0,1,16,0'));
    map.addImage('front-warm-cold', canvas.transferToImageBitmap());

    // taps
    tapsRect(ctx, map, canvas, 'taps-0', 'blue');
    tapsRect(ctx, map, canvas, 'taps-1', 'gray');
    tapsRect(ctx, map, canvas, 'taps-2', 'white');
    tapsRect(ctx, map, canvas, 'taps-3', 'green');
    tapsTriangle(ctx, map, canvas, 'taps-4', 'lightGreen');
    tapsTriangle(ctx, map, canvas, 'taps-5', 'yellow');
    tapsTriangle(ctx, map, canvas, 'taps-6', 'red');

    // jet-stream
    canvas.width = 128;
    canvas.height = 16;
    ctx.lineWidth = 2;
    ctx.strokeStyle = 'rgba(2,128,0,0.8)';
    ctx.fillStyle = 'rgba(2,128,0,0.8)';
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(24, 0);
    ctx.lineTo(32, 8);
    ctx.lineTo(24, 16);
    ctx.lineTo(0, 16);
    ctx.closePath();
    ctx.fill();

    ctx.beginPath();
    ctx.moveTo(30, 0);
    ctx.lineTo(38, 8);
    ctx.lineTo(30, 16);
    ctx.lineTo(128, 16);
    ctx.lineTo(128, 0);
    ctx.closePath();
    ctx.fill();
    map.addImage('jet-stream', canvas.transferToImageBitmap());

    // sprite
    map.addSprite('fe-weather', new URL('sprites/sprite-weather', document.location.href).href);
}

function tapsRect(ctx: OffscreenCanvasRenderingContext2D, map: MaplibreMap, canvas: OffscreenCanvas, name: string, fill: string) {
    ctx.strokeStyle = 'black';
    ctx.fillStyle = fill;
    ctx.beginPath();
    ctx.fillRect(4, 4, 24, 24);
    ctx.strokeRect(4, 4, 24, 24);
    map.addImage(name, canvas.transferToImageBitmap());
}

function tapsTriangle(ctx: OffscreenCanvasRenderingContext2D, map: MaplibreMap, canvas: OffscreenCanvas, name: string, fill: string) {
    ctx.strokeStyle = 'black';
    ctx.fillStyle = fill;
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.fill(new Path2D('M0 32, l32, 0, l-16,-32z'));
    ctx.stroke(new Path2D('M0 32, l32, 0, l-16,-32z'));
    ctx.stroke(new Path2D('M0 32, l16,-9, l16,9z'));
    ctx.stroke(new Path2D('M0 32, l16,-21, l16,21z'));
    map.addImage(name, canvas.transferToImageBitmap());
}
